import type { ErrorInfo } from "react";

import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router";

import { ErrorPage } from "../pages";
import { getEaLogger } from "../state";

const logError = (error: unknown, info: ErrorInfo) => {
    const localLogger = getEaLogger().child({ module: "ErrorBoundaryLayout" });
    localLogger.fatal({ error, info }, "Unhandled Error was caught in global error boundary");
};

export function ErrorBoundaryLayout() {
    return (
        <ErrorBoundary fallbackRender={ErrorPage} onError={logError}>
            <Outlet />
        </ErrorBoundary>
    );
}
